module.exports = __webpack_public_path__ + "static/img/project.0a2182f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brand/project.jpg
// module id = MnQY
// module chunks = 0